import React from 'react';
import markerIcon from '../assets/marker.svg';
import envelopeIcon from '../assets/circle-envelope.svg';
import phoneIcon from '../assets/circle-phone.svg';

const Footer = () => {
  return (
    <footer style={{
      padding: '40px 5%',
      backgroundColor: '#1a73e8',
      color: 'white'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: '40px',
        marginBottom: '40px',
        flexWrap: 'wrap'
      }}>
        {/* Left side - Address and Phone */}
        <div style={{
          flex: '1 1 300px',
          textAlign: 'left'
        }}>
          <h4 style={{
            fontSize: '1rem',
            fontWeight: 700,
            marginBottom: '20px',
            margin: '0 0 20px 0'
          }}>Contact Info</h4>
          
          {/* Contact Info Table */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
          }}>
            {/* Address Row */}
            <div style={{
              display: 'flex',
              gap: '12px',
              alignItems: 'flex-start'
            }}>
              <img 
                src={markerIcon} 
                alt="address" 
                style={{
                  width: '24px',
                  height: '24px',
                  minWidth: '24px',
                  filter: 'brightness(0) invert(1)',
                  opacity: 0.9
                }} 
              />
              <div style={{
                fontSize: '0.95rem',
                lineHeight: 1.5,
                opacity: 0.9
              }}>
                Dim. Gounari & Kifisias Av. 96<br />
                15125, Marousi
              </div>
            </div>

            {/* Email Row */}
            <div style={{
              display: 'flex',
              gap: '12px',
              alignItems: 'center'
            }}>
              <img 
                src={envelopeIcon} 
                alt="email" 
                style={{
                  width: '24px',
                  height: '24px',
                  minWidth: '24px',
                  filter: 'brightness(0) invert(1)',
                  opacity: 0.9
                }} 
              />
              <div style={{
                fontSize: '0.95rem',
                opacity: 0.9
              }}>
                info@peerwatt.com
              </div>
            </div>

            {/* Phone Row */}
            <div style={{
              display: 'flex',
              gap: '12px',
              alignItems: 'center'
            }}>
              <img 
                src={phoneIcon} 
                alt="phone" 
                style={{
                  width: '24px',
                  height: '24px',
                  minWidth: '24px',
                  filter: 'brightness(0) invert(1)',
                  opacity: 0.9
                }} 
              />
              <div style={{
                fontSize: '0.95rem',
                opacity: 0.9
              }}>
                +30 6987750781
              </div>
            </div>

            {/* GEMI Number Row - No icon */}
            <div style={{
              display: 'flex',
              gap: '12px',
              alignItems: 'center',
              marginTop: '8px',
              paddingTop: '8px',
              borderTop: '1px solid rgba(255,255,255,0.2)',
              maxWidth: '200px'
            }}>
              <div style={{
                fontSize: '0.95rem',
                opacity: 0.8
              }}>
                <strong>GEMI:</strong> 182890701000
              </div>
            </div>
          </div>
        </div>

        {/* Center - Logo and Nav */}
        <div style={{
          flex: '1 1 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '20px'
        }}>
          <div style={{ 
            fontSize: '24px', 
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center'
          }}>
            <div style={{
              width: '24px',
              height: '24px',
              backgroundColor: 'white',
              borderRadius: '50%',
              marginRight: '10px'
            }}></div>
            Peerwatt
          </div>
          
          <div style={{
            display: 'flex',
            gap: '20px',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}>
            <a href="#top" style={{ color: 'white', textDecoration: 'none' }}>Home</a>
            <a href="#services" style={{ color: 'white', textDecoration: 'none' }}>Services</a>
            <a href="#expertise" style={{ color: 'white', textDecoration: 'none' }}>Expertise</a>
            <a href="#regions" style={{ color: 'white', textDecoration: 'none' }}>Regions</a>
            <a href="#contact" style={{ color: 'white', textDecoration: 'none' }}>Contact</a>
          </div>
        </div>

        {/* Right side - Empty for balance (optional) */}
        <div style={{
          flex: '1 1 250px'
        }}></div>
      </div>
      
      <div style={{
        textAlign: 'center',
        borderTop: '1px solid rgba(255,255,255,0.2)',
        paddingTop: '20px'
      }}>
        <p style={{ fontSize: '0.9rem', opacity: 0.8, margin: 0 }}>
          © 2026 Peerwatt. All rights reserved. Specialized in energy modeling and consulting services.
        </p>
      </div>
    </footer>
  );
};

export default Footer;